import { useCallback } from "react";
import useAxios from "@Apis/useAxios";
import { GET_ORDERS_CYCLE_PURCHASE_PAYMENT_ERRORS_API, POST_ORDERS_CYCLE_PURCHASE_PAYMENT_ERRORS_API, POST_MEMBERS_CYCLE_PURCHASE_ORDERS_API } from "@Apis/apiPath";

const useOrderCyclePurchaseApi = () => {
	const Axios = useAxios();

	// 循環訂單退訂總覽
	const getOrdersCyclePurchasePaymentErrorsApi = useCallback(
		async params => {
			return await Axios.get(GET_ORDERS_CYCLE_PURCHASE_PAYMENT_ERRORS_API, params);
		},
		// eslint-disable-next-line
		[]
	);

	// 循環訂單明細頁退訂
	const postOrdersCyclePurchasePaymentErrorsApi = useCallback(
		async (cycleOrderID, params) => {
			return await Axios.post(POST_ORDERS_CYCLE_PURCHASE_PAYMENT_ERRORS_API(cycleOrderID), params);
		},
		// eslint-disable-next-line
		[]
	);

    // 取得會員循環訂單收費明細資訊
	const postMembersCyclePurchaseOrdersApi = useCallback(
		async (memberID, cycleOrderID, params) => {
			return await Axios.post(POST_MEMBERS_CYCLE_PURCHASE_ORDERS_API(memberID, cycleOrderID), params);
		},
		// eslint-disable-next-line
		[]
	);

	return {
		getOrdersCyclePurchasePaymentErrorsApi,
		postOrdersCyclePurchasePaymentErrorsApi,
		postMembersCyclePurchaseOrdersApi,
	};
};

export default useOrderCyclePurchaseApi;
